module.exports = __webpack_public_path__ + "static/media/BDO.6cc34416.png";